/* eslint-disable eqeqeq */
import jwtDecode from "jwt-decode";
import APIServices from "../APIServices.js";

/***************************************** ENDPOINTS *****************************************/
const API_POST_NEW_USER = "/user/new";
const API_POST_LOGIN_USER = "/user/login";
const API_SEND_RESET_PASSWORD_EMAIL = "/user/sendResetPasswordEmail";
const API_RESET_PASSWORD_WITH_TOKEN = "/user/resetPasswordWithToken";
const API_CHECK_USER_TOKEN = "/user/checkTokenValid";

const jwtKey = process.env.REACT_APP_JWT_KEY;

// Set Auth Token:
APIServices.setJwt(getJwt());

/***************************************** METHODS *****************************************/
/**
 * Register user
 */
export function register(newUser) {
  return APIServices.post(API_POST_NEW_USER, newUser);
}

/**
 * Login
 */
export async function login(credentials) {
  return APIServices.post(API_POST_LOGIN_USER, credentials);
}

/*
Defined access levels:
-1: Don't grant access
1: Normal access to everything (for admin and guest)
2: Only access to Bosa test Data and User Sessions (HFA control)
3: Other types -> Currently only access to PICs table (Group Industrial control)

*/
export function getAccessControl() {
  try {
    const jwt = localStorage.getItem(jwtKey);
    if (jwt !== undefined && jwt != null) {
      const user = jwtDecode(jwt);

      let role = user.bio.toLowerCase();
      let rolesWithAcess1 = ["admin", "guest"];
      let rolesWithAcess2 = ["verizon"];
      if (role && rolesWithAcess1.includes(role)) {
        return 1;
      } else if (role && rolesWithAcess2.includes(role)) {
        return 2;
      } else {
        return 3;
      }
    } else {
      return -1;
    }
  } catch (ex) {
    return -1;
  }
}

/**
 * Save jwt on LocalStorage
 */
export function loginWithJwt(jwt) {
  localStorage.setItem(jwtKey, jwt);
}

/**
 * Get jwt from LocalStorage
 */
export function getJwt() {
  return localStorage.getItem(jwtKey);
}

/**
 * Logout
 */
export function logout() {
  localStorage.removeItem(jwtKey);
}

/**
 * Get current user.
 */
export function getCurrentUser() {
  try {
    const jwt = localStorage.getItem(jwtKey);
    if (jwt !== undefined && jwt != null) {
      const user = jwtDecode(jwt);
      return user;
    } else {
      return null;
    }
  } catch (ex) {
    return null;
  }
}

export async function getCurrentUserInitial() {
  try {
    const jwt = localStorage.getItem(jwtKey);
    if (jwt !== undefined && jwt != null) {
      const user = jwtDecode(jwt);
      //Verify timestamp expire and delete from local storage automatically if
      //timestamp has passed

      let expired_timestamp = user.exp;
      if (expired_timestamp) {
        let current_timestamp = Math.round(Date.now() / 1000);

        if (current_timestamp > expired_timestamp) {
          logout();
          return null;
        } else {
          //Verify in database if user is still valid - prevent token manipulation
          const reqURL = `${API_CHECK_USER_TOKEN}?token=${jwt}`;
          const result = await APIServices.get(reqURL);
          if (result && result.data && result.data.code == 0) {
            return user;
          } else {
            logout();
            return null;
          }
        }
      } else {
        logout();
        return null;
      }
    } else {
      return null;
    }
  } catch (ex) {
    return null;
  }
}

export function sendResetPasswordEmail(formData, callback) {
  const reqURL = API_SEND_RESET_PASSWORD_EMAIL;
  APIServices.post(reqURL, formData).then((res) => {
    callback(res);
  });
}

export function resetPasswordWithToken(formData, callback) {
  const reqURL = API_RESET_PASSWORD_WITH_TOKEN;
  APIServices.post(reqURL, formData).then((res) => {
    callback(res);
  });
}



// WEBPACK FOOTER //
// ./src/services/users/api_user.js